<ion-content class="ion-padding">
  <h2>Sortierung</h2>
  <ion-radio-group [(ngModel)]="sortValue" (ngModelChange)="select(sortValue)">
    @for (item of sortItems; track item) {
      <ion-item>
        <ion-icon [name]="item.icon" slot="start"></ion-icon>
        <ion-radio [value]="item.typeText">
          <ion-label>{{item.description}}</ion-label>
        </ion-radio>
      </ion-item>
    }
  </ion-radio-group>
</ion-content>